/**
 * React hook for analytics — wraps the lib with screen-view
 * auto-tracking on mount.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track, trackScreenView, AnalyticsEvent } from '../lib/analytics.js';

const ROUTE_NAMES = {
  '/':        'home',
  '/scan':    'scan',
  '/items':   'items',
  '/session': 'session',
  '/summary': 'summary',
  '/join':    'join',
  '/history': 'history',
  '/settings':'settings',
  '/auth':    'auth',
};

export const useScreenTracking = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const screen = ROUTE_NAMES[pathname] ?? pathname.replace('/', '');
    trackScreenView(screen);
  }, [pathname]);
};

export const useAnalytics = () => ({ track, AnalyticsEvent });
